import { React, useEffect, useState } from "react";
import { ModalPopup } from "./modal";
import Iconmoon from "../IconsFiles/icon";
import warning from "../../Assets/Icons/warning.png";
import { Button, Form, Input, Select, Col, Row } from "antd";
import { getUnitData } from "../../Services/measurementService";
import { getReelCoreValues } from "../../Services/settingsServices";
import { HaberForm, DetailFields } from "../../Pages/styledElements";
import styled from "styled-components";
import { editToleranceForOrderSummary } from "../../Services/deckleMatchServices";
import { useForm } from "antd/lib/form/Form";

const ToleranceEditModal = ({
  visible,
  confirmAction,
  cancelAction,
  groupData,
  toleranceLevelType,
  setActionToaster,
  data,
  finalData,
  orderSummaryTable,
  setOrderSummaryTable,
  setData,
  setFinalData,
}) => {
  const [form] = useForm();

  const updateGroupRecords = (lower_bound, upper_bound) => {
    let groups = orderSummaryTable.state.data.groups;
    let selectedGroup = groups.map((group) =>
      group.id === groupData.id
        ? {
            ...group,
            lower_bound_percentage: lower_bound,
            upper_bound_percentage: upper_bound,
            toleranceLevel: toleranceLevelType,
          }
        : group
    );
    setOrderSummaryTable((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        data: {
          ...prevState.state.data,
          groups: selectedGroup,
        },
      },
    }));

    groups = data.groups;
    selectedGroup = groups.map((group) =>
      group.id === groupData.id
        ? {
            ...group,
            lower_bound_percentage: lower_bound,
            upper_bound_percentage: upper_bound,
            toleranceLevel: toleranceLevelType,
          }
        : group
    );

    setData((prevState) => ({
      ...prevState,
      groups: selectedGroup,
    }));

    groups = finalData.groups;
    selectedGroup = groups.map((group) =>
      group.id === groupData.id
        ? {
            ...group,
            lower_bound_percentage: lower_bound,
            upper_bound_percentage: upper_bound,
          }
        : group
    );

    setFinalData((prevState) => ({
      ...prevState,
      groups: selectedGroup,
    }));
  };

  const saveTolerance = async () => {
    const lower_bound = parseFloat(form.getFieldValue("lower_bound"));
    const upper_bound = parseFloat(form.getFieldValue("upper_bound"));
    const strOrders = groupData.orders.map(String);

    const toleranceMapping = {
      "Job Card": "jobcard_level",
      "Order": "order_level",
    };
    let data = {
      group: groupData.id,
      type: toleranceMapping[toleranceLevelType],
      upper_tolerance: upper_bound,
      lower_tolerance: lower_bound,
      order: strOrders,
      units: { weight: "t" },
    };
    await editToleranceForOrderSummary(data)
      .then((response) => {
        updateGroupRecords(lower_bound, upper_bound);
        setActionToaster({
          error: response.error,
          msg: `Changes are successfully saved`,
        });
      })
      .catch((error) => {
        setActionToaster({
          error: error?.response?.data?.error,
          msg: error?.response?.data?.msg,
        });
      });
  };
 
  const handleSave = async () => {
    form
      .validateFields()
      .then(() => {
        saveTolerance();
        confirmAction(); // <-- move this here
      })
      .catch(() => {
        setActionToaster({
          error: true,
          msg: "Please fill all required fields",
        });
      });
  };

  const handleDiscard = async () => {
    if (
      !groupData.lower_bound_percentage &&
      !groupData.upper_bound_percentage
    ) {
      const selectedGroup = orderSummaryTable.state.data.groups.map((group) => {
        if (group.id == groupData.id)
          return { ...group, toleranceLevel: "Order" };
        else return group;
      });
      setOrderSummaryTable((prevState) => ({
        ...prevState,
        state: {
          ...prevState.state,
          data: {
            ...prevState.state.data,
            groups: selectedGroup,
          },
        },
      }));
      setData((prevState) => ({
        ...prevState,
        groups: selectedGroup,
      }));
      setFinalData({ ...data });
    }
    cancelAction();
  };
  return (
    <ModalPopup
      visible={visible}
      width={"344px"}
      maskStyle={{ width: "444px" }}
    >
      <>
        <div className="resetPassForm removePadLeft">
          <DetailFields
            className="marginBtnP"
            style={{ paddingBottom: "15px" }}
          >
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className=" haberSignup"
                style={{ marginTop: "0" }}
                form={form}
              >
                <div
                  className="drawerField"
                  style={{
                    borderBottom: "0px solid #edebe9",
                  }}
                >
                  <Row>
                    <Col>
                      <div className="titleWithText">
                        <h2
                          style={{
                            // marginLeft: "40px",
                            // marginBottom: "4px",
                            fontSize: "16px",
                            fontWeight: "600",
                            textAlign: "center",
                          }}
                        >
                          Job Card Level Tolerance
                        </h2>
                        <p
                          style={{
                            // marginLeft: "3px",
                            marginBottom: "15px",
                            textAlign: "center",
                          }}
                        >
                          Enter lower & upper bound values for selected order
                        </p>
                      </div>
                    </Col>
                    <Col style={{paddingBottom: "15px"}}>
                      <Row>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span>Enter Lower Bound</span>
                        </Col>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div className="boxFormType">
                            <Form.Item
                              name="lower_bound"
                              className="selectForm"
                              initialValue={groupData.lower_bound_percentage}
                              style={{ marginBottom: "0px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  validator: (_, value) => {
                                    if (parseFloat(value) <= 0) {
                                      return Promise.reject(
                                        "Should be non-zero positive number"
                                      );
                                    }
                                    if (!/^\d+(\.\d{1,3})?$/.test(value)) {
                                      return Promise.reject(
                                        "Only up to 3 decimal digits allowed"
                                      );
                                    }
                                    if(parseFloat(value)>100){
                                      return Promise.reject("Should be less than equal to 100")
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <Input
                                placeholder="LB"
                                className="inputField"
                                style={{ paddingLeft: "10px" }}
                              />
                            </Form.Item>

                            <span className="nonEditable">%</span>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col>
                      <Row>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span
                            style={{
                              marginLeft: "3px",
                              fontSize: "14px",
                            }}
                          >
                            Enter Upper Bound
                          </span>
                        </Col>
                        <Col
                          span={12}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <div className="boxFormType">
                            <Form.Item
                              name="upper_bound"
                              className="selectForm"
                              initialValue={groupData.upper_bound_percentage}
                              dependencies={["lower_bound"]} // <-- enables cross-field validation
                              rules={[
                                {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  validator: (_, value, callback) => {
                                    const lower =
                                      form.getFieldValue("lower_bound");
                                    if (parseFloat(value) <= 0) {
                                      return Promise.reject(
                                        "Should be non-zero positive number"
                                      );
                                    }
                                    // if (
                                    //   parseFloat(value) <= parseFloat(lower)
                                    // ) {
                                    //   return Promise.reject(
                                    //     "Upper bound should be greater than lower bound"
                                    //   );
                                    // }
                                    if (!/^\d+(\.\d{1,3})?$/.test(value)) {
                                      return Promise.reject(
                                        "Only up to 3 decimal digits allowed"
                                      );
                                    }
                                    if(parseFloat(value)>100){
                                      return Promise.reject("Should be less than equal to 100")
                                    }
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                              style={{ marginBottom: "0px" }}
                            >
                              <Input
                                placeholder="UB"
                                className="inputField"
                                style={{ paddingLeft: "10px" }}
                              />
                            </Form.Item>

                            <span className="nonEditable">%</span>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => handleDiscard()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>
          <Button
            key="submit"
            type="submit"
            className="themeBtn"
            onClick={handleSave}
          >
            <Iconmoon icon="edit" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </>
    </ModalPopup>
  );
};

export default ToleranceEditModal;
